<template>
  <div
      v-if="show"
      class="apartment-type-wrap flex between align-center mb-2"
  >
    <fp-custom-drop-down
        :value="value"
        :name="name"
        :options="options"
        @change="change($event)"
        :styleObject="{maxHeight: '150px'}"
    ></fp-custom-drop-down>
  </div>
</template>
<script>
import FpCustomDropDown from "@/components/buttons/FpCustomDropDown.vue";

export default {
  name: "FilterDropdown",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    name: {
      type: String,
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    FpCustomDropDown
  },
  methods: {
    change(value) {
      this.$emit("change", value);
    }
  }
}
</script>